/**
 * 管理ダッシュボード（/admin）の定数
 */

export const ADMIN_STAT_RANGES = [7, 30, 90] as const;
export type AdminStatRange = (typeof ADMIN_STAT_RANGES)[number];

export const ADMIN_DEFAULT_RANGE: AdminStatRange = 30;

export const ADMIN_RANGE_LABELS: Record<AdminStatRange, string> = {
  7: '7日',
  30: '30日',
  90: '90日',
};

/** 管理APIアクセスログの結果種別 */
export const ADMIN_ACCESS_OUTCOME = {
  OK: 'ok',
  DENIED: 'denied',
  UNAUTHORIZED: 'unauthorized',
} as const;

export const ADMIN_ACCESS_OUTCOME_LABELS: Record<string, string> = {
  [ADMIN_ACCESS_OUTCOME.OK]: '許可',
  [ADMIN_ACCESS_OUTCOME.DENIED]: '拒否',
  [ADMIN_ACCESS_OUTCOME.UNAUTHORIZED]: '未認証',
};

/** Cognito の管理者グループ名 */
export const ADMIN_COGNITO_GROUP = 'admin';

/** リファラ不明ランディングの内部キー（バックエンドの DIRECT_REFERRER と対応） */
export const DIRECT_REFERRER_KEY = 'direct';

/** 流入元の表示ラベル（direct は「(直接/不明)」として表示） */
export function formatReferrerLabel(referrer: string): string {
  return referrer === DIRECT_REFERRER_KEY ? '(直接/不明)' : referrer;
}

/** AWS Billing コンソール（コスト詳細の深掘り用） */
export const AWS_BILLING_CONSOLE_URL =
  'https://us-east-1.console.aws.amazon.com/costmanagement/home#/home';
